"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m11.596 11.881.05.007.015.13.019-.124c.022.003.05.007.08.02l.041.021.059.04.03.017.037.028 1.969 1.892a.512.512 0 0 1 .014.733.536.536 0 0 1-.662.07l-.071-.056-1.092-1.048v9.027c0 .306-.213.52-.52.52a.493.493 0 0 1-.51-.421l-.008-.099v-9.027L9.955 14.66a.533.533 0 0 1-.733-.014.519.519 0 0 1-.04-.672l.055-.062 1.97-1.892.035-.027.058-.036a.32.32 0 0 1 .073-.042l.043-.013.037-.007.06.115-.027-.122a.46.46 0 0 1 .11-.006ZM11.488.841c3.51 0 6.588 2.484 7.352 5.918 2.893.209 5.145 2.563 5.145 5.399-.078 2.95-2.455 5.363-5.345 5.48l-.218.004H13.93a.497.497 0 0 1-.518-.52c0-.271.168-.47.42-.51l.098-.008h4.492a4.45 4.45 0 0 0 4.445-4.446 4.45 4.45 0 0 0-4.445-4.446c-.282 0-.598-.188-.598-.44-.46-3.066-3.186-5.392-6.337-5.392-3.58 0-6.494 2.879-6.494 6.416 0 .313 0 .54.077.92.002.119.002.314-.113.429-.093.092-.237.111-.338.115h-.145a3.425 3.425 0 0 0-3.421 3.422 3.426 3.426 0 0 0 3.233 3.417l.188.005h4.728c.306 0 .519.213.519.518a.493.493 0 0 1-.421.512l-.098.008H4.474c-2.417 0-4.46-2.042-4.46-4.46 0-2.228 1.58-4.036 3.802-4.413l.218-.032v-.823A7.08 7.08 0 0 1 6.08 3.086C7.499 1.639 9.419.842 11.488.842Z",
    clipRule: "evenodd"
  })]
});